import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import auth from './auth/reducer';
import user from './user/reducer';
import employee from './employee/reducer';
import deals from './deals/reducer';
import logins from './logins/reducer';
import sourceMappings from './sourceMappings/reducer';
import forms from './forms/reducer';
import formPacks from './formPacks/reducer';
import dealers from './dealers/reducer';
import feeds from './feeds/reducer';
import pen from './pen/reducer';
import feedMappings from './feedMappings/reducer';
import feedviews from './feedviews/reducer';
import websites from './websites/reducer';
import roles from './roles/reducer';
import global from './global/reducer';
import permissions from './permissions/reducer';
import widgets from './widgets/reducer';
import fonts from './fonts/reducer';
import verifications from './verifications/reducer';
import analytics from './analytics/reducer';
import dealerDataRevisions from './dealerDataRevisions/reducer';
import cars from './cars/reducer';
import translations from './translations/reducer';
import accessories from './accessories/reducer';
import groups from './groups/reducer';
import outreachForms from './outreachForms/reducer';

const createRootReducer = (history) =>
  combineReducers({
    auth,
    user,
    employee,
    deals,
    logins,
    sourceMappings,
    dealers,
    groups,
    feeds,
    feedMappings,
    feedviews,
    websites,
    roles,
    fonts,
    forms,
    formPacks,
    global,
    pen,
    router: connectRouter(history),
    permissions,
    widgets,
    verifications,
    analytics,
    dealerDataRevisions,
    cars,
    translations,
    accessories,
    outreachForms,
  });

export default createRootReducer;
